module.exports = __webpack_public_path__ + "img/ic_services_laundryservice.342ee755.svg";